const icons = {
	'arrow-left': (
		<svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
			<path fill="currentColor" d="m44.97,22H11.11l7.89-8.47c1.13-1.21,1.06-3.11-.15-4.24-1.21-1.13-3.11-1.06-4.24.15L2.02,22.95c-.05.05-.08.11-.12.16-.05.06-.1.11-.14.18-.02.03-.04.06-.06.09-.05.08-.09.15-.13.23-.03.06-.07.12-.1.19-.01.03-.02.07-.04.1-.03.08-.06.17-.08.26-.02.07-.05.13-.06.2,0,.03-.01.07-.02.11-.02.09-.02.17-.03.26,0,.08-.02.15-.02.23,0,.02,0,.03,0,.05,0,.02,0,.03,0,.05,0,.08.01.16.02.24,0,.08.01.16.03.25,0,.03.01.07.02.1.02.07.04.14.06.21.02.08.05.17.08.25.01.03.02.07.04.1.03.07.07.13.1.2.04.08.08.15.12.23.02.03.04.06.06.09.04.06.1.12.15.18.04.05.07.11.12.16l12.59,13.51c.59.63,1.39.96,2.2.96.73,0,1.47-.27,2.04-.81,1.21-1.13,1.28-3.03.15-4.24l-7.89-8.47h33.86c1.66,0,3-1.34,3-3s-1.34-3-3-3Z" />
		</svg>
	),
	'arrow-right': (
		<svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
			<path fill="currentColor" d="m5.03,28h33.86l-7.89,8.47c-1.13,1.21-1.06,3.11.15,4.24,1.21,1.13,3.11,1.06,4.24-.15l12.59-13.51c.05-.05.08-.11.12-.16.05-.06.1-.11.14-.18.02-.03.04-.06.06-.09.05-.08.09-.15.13-.23.03-.06.07-.12.1-.19.01-.03.02-.07.04-.1.03-.08.06-.17.08-.26.02-.07.05-.13.06-.2,0-.03.01-.07.02-.11.02-.09.02-.17.03-.26,0-.08.02-.15.02-.23,0-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0-.08-.01-.16-.02-.24,0-.08-.01-.16-.03-.25,0-.03-.01-.07-.02-.1-.02-.07-.04-.14-.06-.21-.02-.08-.05-.17-.08-.25-.01-.03-.02-.07-.04-.1-.03-.07-.07-.13-.1-.2-.04-.08-.08-.15-.12-.23-.02-.03-.04-.06-.06-.09-.04-.06-.1-.12-.15-.18-.04-.05-.07-.11-.12-.16l-12.59-13.51c-.59-.63-1.39-.96-2.2-.96-.73,0-1.47.27-2.04.81-1.21,1.13-1.28,3.03-.15,4.24l7.89,8.47h-33.86c-1.66,0-3,1.34-3,3s1.34,3,3,3Z" />
		</svg>
	),
	'arrow-up': (
		<svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
			<path fill="currentColor" d="m28,44.97v-33.86l8.47,7.89c1.21,1.13,3.11,1.06,4.24-.15,1.13-1.21,1.06-3.11-.15-4.24l-13.51-12.59c-.05-.05-.11-.08-.16-.12-.06-.05-.11-.1-.18-.14-.03-.02-.06-.04-.09-.06-.08-.05-.15-.09-.23-.13-.06-.03-.12-.07-.19-.1-.03-.01-.07-.02-.1-.04-.08-.03-.17-.06-.26-.08-.07-.02-.13-.05-.2-.06-.03,0-.07-.01-.11-.02-.09-.02-.17-.02-.26-.03-.08,0-.15-.02-.23-.02-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0-.08,0-.16.01-.24.02-.08,0-.16.01-.25.03-.03,0-.07.01-.1.02-.07.02-.14.04-.21.06-.08.02-.17.05-.25.08-.03.01-.07.02-.1.04-.07.03-.13.07-.2.1-.08.04-.15.08-.23.12-.03.02-.06.04-.09.06-.06.04-.12.1-.18.15-.05.04-.11.07-.16.12l-13.51,12.59c-.63.59-.96,1.39-.96,2.2,0,.73.27,1.47.81,2.04,1.13,1.21,3.03,1.28,4.24.15l8.47-7.89v33.86c0,1.66,1.34,3,3,3s3-1.34,3-3Z" />
		</svg>
	),
	'arrow-down': (
		<svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
			<path fill="currentColor" d="m22,5.03v33.86l-8.47-7.89c-1.21-1.13-3.11-1.06-4.24.15-1.13,1.21-1.06,3.11.15,4.24l13.51,12.59c.05.05.11.08.16.12.06.05.11.1.18.14.03.02.06.04.09.06.08.05.15.09.23.13.06.03.12.07.19.1.03.01.07.02.1.04.08.03.17.06.26.08.07.02.13.05.2.06.03,0,.07.01.11.02.09.02.17.02.26.03.08,0,.15.02.23.02.02,0,.03,0,.05,0,.02,0,.03,0,.05,0,.08,0,.16-.01.24-.02.08,0,.16-.01.25-.03.03,0,.07-.01.1-.02.07-.02.14-.04.21-.06.08-.02.17-.05.25-.08.03-.01.07-.02.1-.04.07-.03.13-.07.2-.1.08-.04.15-.08.23-.12.03-.02.06-.04.09-.06.06-.04.12-.1.18-.15.05-.04.11-.07.16-.12l13.51-12.59c.63-.59.96-1.39.96-2.2,0-.73-.27-1.47-.81-2.04-1.13-1.21-3.03-1.28-4.24-.15l-8.47,7.89v-33.86c0-1.66-1.34-3-3-3s-3,1.34-3,3Z" />
		</svg>
	)
};

export default function Icon({ name, className = '', size = 20, ...props }) {
	const IconComponent = icons[name];
	
	if (!IconComponent) {
		console.warn(`Icon "${name}" not found. Available icons:`, Object.keys(icons));
		return null;
	}

	return (
		<span 
			className={`icon ${className}`}
			style={{ 
				display: 'inline-block',
				width: size,
				height: size,
				...props.style 
			}}
			{...props}
		>
			{IconComponent}
		</span>
	);
}

// Export des noms d'icônes pour auto-complétion
export const iconNames = Object.keys(icons);